import { formatDataValue } from 'utils/formatFns';
import { getCurrentStatusChip } from 'pages/VehicleDetails/sectionMappingVehicleInquiry/vehicleAssignment';

export const dealerAssignmentFields = {
  allocationNumber: {
    label: 'Allocation Number',
    getValue: (data) => data?.generalInfo?.dealerAssignmentInfo?.allocationNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  allocationSeries: {
    label: 'Allocation Series',
    getValue: (data) => ({
      code: data?.generalInfo?.dealerAssignmentInfo?.allocationSeriesCode,
      description: data?.generalInfo?.dealerAssignmentInfo?.allocationSeriesDescription,
    }),
    formatValue: ({ code, description }) =>
      `${formatDataValue({ value: code })} | ${formatDataValue({ value: description })}`,
  },
  assignmentComments: {
    label: 'Assignment Comments',
    getValue: (data) => data?.generalInfo?.dealerAssignmentInfo?.dealerAssignmentComment,
    formatValue: (value) => formatDataValue({ value }),
  },
  comments: {
    label: 'Comments',
    getValue: (data) => data?.generalInfo?.dealerAssignmentInfo?.dealerAssignmentComment,
    formatValue: (value) => formatDataValue({ value }),
  },
  currentStatus: {
    label: 'Current Status',
    getValue: (data) => ({
      allocationInProcessDescription:
        data?.generalInfo?.dealerAssignmentInfo?.allocationInProcessDescription,
      vehicleAssignmentIndicator:
        data?.generalInfo?.dealerAssignmentInfo?.vehicleAssignmentIndicator,
    }),
    formatValue: ({ allocationInProcessDescription, vehicleAssignmentIndicator }, options = {}) => {
      return getCurrentStatusChip(
        allocationInProcessDescription,
        vehicleAssignmentIndicator,
        options.isPrint,
        options.searchContextValues,
        options.isShowTooltip,
      );
    },
  },
  gmpAssignmentArea: {
    label: 'GMP Assignment Area',
    getValue: (data) => ({
      regionCode: data?.generalInfo?.dealerAssignmentInfo?.dealerAllocationHistory?.[0]?.regionCode,
      regionName: data?.generalInfo?.dealerAssignmentInfo?.dealerAllocationHistory?.[0]?.regionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  gmpAssignmentDealer: {
    label: 'GMP Assignment Dealer',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.dealerAssignmentInfo?.dealerAllocationHistory?.[0]?.dealerCode,
      dealerName: data?.generalInfo?.dealerAssignmentInfo?.dealerAllocationHistory?.[0]?.dealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  gmpIndicator: {
    label: 'GMP Indicator',
    getValue: (data) => data?.generalInfo?.dealerAssignmentInfo?.gmpCode,
    formatValue: (value) => (value ? 'Y' : 'N'),
  },
  pipelineProtection: {
    label: 'Pipeline Protection',
    getValue: (data) => data?.generalInfo?.dealerAssignmentInfo?.pipelineProtectionIndicator,
    formatValue: (value) => (value ? 'Y' : 'N'),
  },
  tradeType: {
    label: 'Trade Type',
    getValue: (data) => data?.generalInfo?.dealerAssignmentInfo?.tradeType,
    formatValue: (value) => formatDataValue({ value }),
  },
};
